export const DISNEY_PROMO_ID = '21015';
export const VISION_FEATURE_CODE = '2641';
export const SPL_DISCOUNT_PROMO_IDS = ['18567', '18882'];
export const NETMAX_PROMO_ID = '21025';
export const NETMAX_PRODUCT_ID = '2839';
export const NETMAX_12MONTHS_SUBTITLE = 'Offer price for 12 months';
export const MOBILE_HOME_PERK_CREDIT = 'MOBILE + HOME PERK CREDIT'
export const DISNEY_ADVANCE_PERK_ID = '3369';